import type { ReactNode } from 'react';
import { cn } from '../utils.js';

export function Card({ title, children, className }: { title?: string; children: ReactNode; className?: string }) {
  return (
    <section
      className={cn('card-block rounded-xl border border-border bg-card p-6 shadow-(--shadow-card)', className)}
    >
      {title && <h2 className="mb-4 text-lg font-semibold tracking-tight">{title}</h2>}
      {children}
    </section>
  );
}

export function EmptyState({ label }: { label: string }) {
  return <div className="py-10 text-center text-sm text-muted-foreground">{label}</div>;
}
